import * as types from '../mutation-types'
import axios from 'axios'
import authentication from '../../api/authentication'

const state = {
    loggedInCustomer: {},
    token: '',
    header: {},
    isLoggedIn: false,
    isRegistered: false,
    activeScreen: 'home',
    isAdmin: false
}

const getters = {
    token: state => state.token,
    loggedInCustomer: state => state.loggedInCustomer,
    isLoggedIn: state => state.isLoggedIn,
    header: state => state.header,
    isRegistered: state => state.isRegistered,
    activeScreen: state => state.activeScreen,
    isAdmin: state => state.isAdmin
}

const actions = {
    login({ commit }, credentials) {
        return authentication.login(credentials).then((response) => {
            if (response.data.success) {
                window.sessionStorage.setItem('token', JSON.stringify(response.data.jwt.token))
                window.sessionStorage.setItem('customer', JSON.stringify(response.data.message))
                commit(types.LOGIN_CUSTOMER)
                commit(types.SET_TOKEN, response.data.jwt.token)
                commit(types.SET_LOGGED_IN_CUSTOMER, response.data.message)
                commit(types.SET_HEADER, response.data.jwt.token)
            }
        })
    },
    validateCustomer({ commit }) {
        return authentication.validateCustomer().then((response) => {
            if (response.data.success) {
                window.sessionStorage.setItem('customer', JSON.stringify(response.data.message))
                commit(types.LOGIN_CUSTOMER)
                commit(types.SET_TOKEN, JSON.parse(window.sessionStorage.getItem('token')))
                commit(types.SET_LOGGED_IN_CUSTOMER, response.data.message)
                commit(types.SET_HEADER, JSON.parse(window.sessionStorage.getItem('token')))
            } else {
                localStorage.clear()
                window.sessionStorage.clear()
                commit(types.LOGOUT_CUSTOMER)
            }
        })
    },
    logout({ commit }) {
        localStorage.clear()
        window.sessionStorage.clear()
        commit(types.LOGOUT_CUSTOMER)
    }
}

const mutations = {
    [types.LOGIN_CUSTOMER](state) {
        state.isLoggedIn = true
    },

    [types.LOGOUT_CUSTOMER](state) {
        state.isLoggedIn = false
        state.loggedInCustomer = {}
    },

    [types.SET_LOGGED_IN_CUSTOMER](state, payload) {
        state.loggedInCustomer = payload
    },

    [types.SET_TOKEN](state, payload) {
        state.token = payload
    },

    [types.SET_ACTIVE_SCREEN](state, payload) {
        state.activeScreen = payload
    },

    [types.SET_HEADER](state, payload) {
        axios.defaults.headers.common = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + payload
        }

        state.header = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + payload
        }
    },

    [types.SET_ADMIN](state, payload) {
        state.isAdmin = payload
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
